import instance from "../../../../../services/api";

export const getDebtsAmount = async (params = {}) => {
  return await instance(true)
    .get(`/partner/teams/debts/`, { params })
    .then(res => res?.data);
};
